export const SUBSCRIPTION_TOGGLE_MODAL_SUCCESS =
  "API/UI/SUBSCRIPTION/TOGGLE_MODAL_SUCCESS";
